export default __webpack_public_path__ + "static/media/video-advertise3.57de4943.png";